export default function ConfigTranslation($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('electron');
}

ConfigTranslation.$inject = ['$translatePartialLoaderProvider'];
